import {
  setCurrentStep,
  setFieldError,
  // setFieldValue,
  setLoading,
} from "@/stores";
import {
  checkEmailAvailability,
  // checkPhoneAvailability,
  // sendPhoneCode,
} from "./index";
import { pushAnalyticsError } from "@/helpers";

export const submitAccountDetails = async (values: any) => {
  setLoading(true);
  setFieldError("general", "");

  // let phonePrefix = "";

  // if (!values.phonePrefix) {
  //   setFieldValue("phonePrefix", "+48");
  //   phonePrefix = "+48";
  // } else {
  //   phonePrefix = values.phonePrefix;
  // }

  // const phoneNumber = `${phonePrefix}${values.phoneNumber.replaceAll(" ", "")}`;

  // Check availability
  const emailIsAvailable = await checkEmailAvailability(values.email);
  // const phoneIsAvailable = await checkPhoneAvailability(phoneNumber);

  setFieldError(
    "email",
    !emailIsAvailable ? "E-mail has already been used" : ""
  );
  // setFieldError(
  //   "phoneNumber",
  //   !phoneIsAvailable ? "Phone number has already been used" : ""
  // );

  if (!emailIsAvailable) {
    // || !phoneIsAvailable) {
    // Push error event for availability issues
    const errorFields: string[] = [];
    const errorMessages: string[] = [];

    if (!emailIsAvailable) {
      errorFields.push("email");
      errorMessages.push("E-mail has already been used");
    }
    // if (!phoneIsAvailable) {
    //   errorFields.push("phone");
    //   errorMessages.push("Phone number has already been used");
    // }

    pushAnalyticsError({
      event: "signup_error",
      errorCode: "email_exists",
      errorMessage: errorMessages.join("; ") || "E-mail has already been used",
      errorStep: "account_details",
      method: "email",
    });

    setLoading(false);
    return;
  }

  // Send phone code
  // const isSent = await sendPhoneCode(phoneNumber);

  // if (isSent) {
  setCurrentStep(2); // Przechodzimy do kroku 2 (hasło), który był wcześniej krokiem 3
  // } else {
  //   setFieldError("phoneNumber", "Something went wrong!");

  //   // Push error event for server error
  //   pushDataLayerEvent({
  //     event: "signup_error",
  //     error_type: "server_error",
  //   });
  // }

  setLoading(false);
};
